import { render } from "./PrestationAccueil.vue?vue&type=template&id=4bd286d2&scoped=true"
import script from "./PrestationAccueil.vue?vue&type=script&lang=js"
export * from "./PrestationAccueil.vue?vue&type=script&lang=js"

import "./PrestationAccueil.vue?vue&type=style&index=0&id=4bd286d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd286d2"]])

export default __exports__